// import { getAuth, signInWithEmailAndPassword , setPersistence } from "firebase/auth";
import firebase from '../firebase'


export const signin = async(email, password)=>{
    try{
        
        await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        const user = await firebase.auth().signInWithEmailAndPassword(email, password)
        // console.log(user.user)

        return user.user
    }catch(err){
        // console.log("in firebase signin", err)
        return {"error":err}
    }
}

export const signinGoogle = async()=>{
    try{
        var provider = new firebase.auth.GoogleAuthProvider()
        provider.addScope('https://www.googleapis.com/auth/userinfo.email');
        provider.addScope('https://www.googleapis.com/auth/userinfo.profile');

        const res = await firebase.auth().signInWithPopup(provider)
        return res.user;

    }catch(error){
        return { error };
    }
}
export const logout=async()=>{
    try{
        await firebase.auth().signOut();
    }catch(err){
        // console.log(err)
    }
}

// Guests browse with an anonymous Firebase token (see firebase.js), so only a
// real, non-anonymous account counts as "logged in" for navbar/profile checks.
export const getState = ()=>{
    const user = firebase.auth().currentUser;
    return !!(user && !user.isAnonymous)
}

export const getUser= async()=>{
    const user = await firebase.auth().currentUser;
    // console.log("from funtion", user)
    if(user){
        return user
    }else{
        return false;
    }
}

export const signup = async()=>{
    
}

